function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTimelineSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 112",
    style: {
      fill: "#fff",
      stroke: "#60a7b9"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 114",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(2 2)",
    style: {
      fill: "#60a7b9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTimelineSub);
export default __webpack_public_path__ + "static/media/ico-timeline-sub.7a6e5c93e02d2fa51cc537b3dc0709da.svg";
export { ForwardRef as ReactComponent };